import styled from 'styled-components';

export const Title = styled.h2`
  margin-bottom: 40px;
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
`;
